import React from 'react'
import {
  Container,
  Divider
} from 'semantic-ui-react'
import { format } from 'date-fns'
// Local
import { shouldRenderReskin2025 } from '../../constant'

function Footer(): JSX.Element {
  const shouldReskinClassName = shouldRenderReskin2025
    ? ' reskin'
    : ''
  const companyName = shouldRenderReskin2025
    ? 'Reveleer'
    : 'Curation Health'
  return (
    <Container
      className={ `footer${shouldReskinClassName}` }
      id="footer"
    >
      <Divider className={ `footer-divider${shouldReskinClassName}` } />
      <div className="right-text">
        { companyName } Copyright &#169; { format(new Date(), 'YYYY') }
      </div>
    </Container>
  )
}

export default Footer
